export enum Layout {
  mobile = "mobile",
  desktop = "desktop",
}
